export default "__VITE_ASSET__BEHoOGgx__"